/**
 * Close navigation-drawer (e.g. #header-sidebar-menu) after tapping a real nav link.
 * Lives in its own asset so merchants can edit theme.liquid only if sections.js is awkward to open in admin.
 */
document.addEventListener(
	'click',
	(event) => {
		const drawer = event.target.closest('navigation-drawer')
		if (!drawer || !drawer.hasAttribute('open')) {
			return
		}
		if (event.defaultPrevented) {
			return
		}
		const link = event.target.closest('a[href]')
		if (!link || !drawer.contains(link)) {
			return
		}
		const href = (link.getAttribute('href') || '').trim()
		if (!href || href === '#' || /^javascript:/i.test(href)) {
			return
		}
		if (typeof drawer.hide === 'function') {
			drawer.hide()
		}
	},
	true,
)
